/**
 * Created by linjianxi on 2016/10/27.
 */
export const initSet = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/setting/getter.js